module.exports = __webpack_public_path__ + "static/media/x.9da18ac8.png";